export default "__VITE_PUBLIC_ASSET__80bfd719__"